import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('as-no-search-results')
export class NoSearchResults extends LitElement {
  public static styles = css`
    .no-search-results {
      padding-block: 8%;
      text-align: center;
      font-size: 1.2rem;
      color: color-mix(in srgb, #000000 30%, #ffffff 70%);
    }
  `;

  @property()
  public caption!: string;

  public render() {
    return html`<div class="no-search-results">
      <div class="icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          fill="currentColor"
          class="bi bi-search"
          viewBox="0 0 16 16"
        >
          <path
            d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
          />
        </svg>
      </div>
      <div class="caption">${this.caption}</div>
    </div>`;
  }
}
